import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Markup } from 'interweave';

export default function OurServices(){
    const { t } = useTranslation();
    const services = ["datamanagement", "testing", "architecture", "cybersecurity", "devops"];

    return(
        <article id="ourservices">
            <section className="our-services">
                <Container>
                    <Row>
                        <Col>
                            <div class="section-highlight">{t('whatwedo.ourservices.title')}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="content-container">
                                {services.map(item=>{
                                    return(
                                        <Row className="mb-4" id={item}>
                                            <Col md={2}>
                                                <div className={`icon-placeholder ${item}`}>
                                                    <div className="icon"></div>
                                                </div>
                                            </Col>
                                            <Col md={10}>
                                                <div className="title">{t(`whatwedo.ourservices.${item}.title`)}</div>
                                                <div className="description"><Markup content={t(`whatwedo.ourservices.${item}.description`)}></Markup></div>
                                            </Col>
                                        </Row>
                                    )
                                })}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </article>
    )
}